import { inject } from '@angular/core'
import { HttpInterceptorFn } from '@angular/common/http'
import { toObservable } from '@angular/core/rxjs-interop'
import { filter, switchMap } from 'rxjs/operators'
import { ProfileStore } from '@core/store/profile/profile.store'

export const tokenInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.url.includes('assets/')) {
    return next(request)
  }

  const profileStore = inject(ProfileStore)

  return toObservable(profileStore.oidcFormattedToken).pipe(
    filter((token): token is string => !!token),
    switchMap((token) =>
      next(
        request.clone({
          headers: request.headers.set('Authorization', token),
        }),
      ),
    ),
  )
}
